import { useMutation } from '@apollo/react-hooks';

import { mapDatasetCreate, fetchMap } from 'graphql/queries';

const CreateMapDatasetService = (pageId) => {
  const [createMapDataset] = useMutation(mapDatasetCreate, {
    refetchQueries: [{
      query: fetchMap,
      variables: ({ id: pageId }),
    }],
  });

  return ({ createMapDataset });
};

export default CreateMapDatasetService;
